const { default: styled } = require("styled-components");

export const Container = styled.div`
	margin: 1.5rem 0;
`
